"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActivity = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const activity_1 = require("../core/activity");
const proficiencyLevel_1 = require("../core/proficiencyLevel");
const activityPayloadSchema = zod_1.z.object({
    proficiencyLevel: proficiencyLevel_1.proficiencyLevelSchema,
    moduleId: zod_1.z.string(),
    title: zod_1.z.string(),
    difficulty: activity_1.activityDifficultyEnum,
    description: zod_1.z.string(),
    format: activity_1.activityFormatEnum,
    voiceId: zod_1.z.string(),
    externalSourceId: zod_1.z.string().optional(),
    index: zod_1.z.number().optional(),
    executeSync: zod_1.z.boolean().optional(),
    skipVideoGeneration: zod_1.z.boolean().optional(),
});
exports.createActivity = (0, core_1.makeEndpoint)({
    method: "post",
    path: "/private/activity",
    alias: "createActivity",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: activityPayloadSchema,
        },
    ],
    response: zod_1.z.object({
        success: zod_1.z.boolean(),
        activityId: zod_1.z.string().optional(),
    }),
});
//# sourceMappingURL=createActivity.js.map